"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Month;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SimpleDate = require("../../core/SimpleDate");

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

var _AbstractMonth = _interopRequireDefault(require("./AbstractMonth"));

var _Day = _interopRequireDefault(require("./Day"));

function Month(props) {
  var month = props.month,
      onChange = props.onChange,
      value = props.value,
      rest = (0, _objectWithoutProperties2.default)(props, ["month", "onChange", "value"]);
  return _react.default.createElement(_AbstractMonth.default, Object.assign({}, rest, {
    month: month,
    onDateClick: onChange
  }), function (simpleDate, dayProps) {
    var isSelected = (0, _SimpleDate.equals)(simpleDate, value);
    return _react.default.createElement(_Day.default, Object.assign({}, dayProps, {
      isSelected: isSelected
    }), simpleDate.date);
  });
}

if (process.env.NODE_ENV !== 'production') {
  Month.propTypes = {
    disabledValues: _propTypes.default.array,
    focusedValue: _SimpleDateTypes.SimpleDateType,
    leftControl: _propTypes.default.node,
    max: _SimpleDateTypes.SimpleDateType,
    maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    min: _SimpleDateTypes.SimpleDateType,
    minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string).isRequired,
    month: _propTypes.default.number.isRequired,
    onChange: _propTypes.default.func.isRequired,
    ownerId: _propTypes.default.string.isRequired,
    rightControl: _propTypes.default.node,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    value: _SimpleDateTypes.SimpleDateType,
    weekdayHeadings: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
    weekStartDay: _propTypes.default.number.isRequired,
    year: _propTypes.default.number.isRequired
  };
}

module.exports = exports.default;